export const translate = (dict, phrase) => {
    return dict[phrase] || phrase;
};
//# sourceMappingURL=translate.js.map